export class ContextMenuState {
  public itemIndex: number = 0;
  public menuItemIndex: number = 0;

  constructor(public count: number = 0) {}

  public reset() {
    this.itemIndex = 0;
    this.menuItemIndex = 0;
    this.count = 0;
  }
}
